import React from "react";
import { EventEmitterX } from "../../../helpers/events";

const DashboardContext = React.createContext({ eventEmitter: null, searchText: "" });

const DashboardContextProvider = (props) => {
    return (
        <DashboardContext.Provider value={{ eventEmitter: new EventEmitterX(), searchText: "" }}>
            {props.children}
        </DashboardContext.Provider>
    );
}

export { DashboardContext, DashboardContextProvider };